import React from 'react'
import { FaGithub } from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'
import { BsFillPersonLinesFill } from 'react-icons/bs'

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          Github <FaGithub size={22} />
        </>
      ),
      href: 'https://github.com/AakashJha04',
      target: '_blank',
      rel: 'noreferrer',
    },
    {
      id: 2,
      child: (
        <>
          Mail <HiOutlineMail size={22} />
        </>
      ),
      href: 'mailto:aakashanand560@gmail.com?subject=Hello%20Aakash',
      target: '_self',
    },
    {
      id: 3,
      child: (
        <>
          Resume <BsFillPersonLinesFill size={22} />
        </>
      ),
      href: '/resume.pdf',
      download: true,
      target: '_blank',
      rel: 'noreferrer',
    },
  ]

  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed z-40">
      <ul>
        {links.map(({ id, child, href, download, target, rel }) => (
          <li
            key={id}
            className="flex h-12 w-36 items-center justify-between rounded-r-lg border border-slate-200 bg-white px-4 ml-[-96px] text-slate-700 shadow-sm duration-200 hover:ml-[-8px] hover:border-indigo-200 hover:text-indigo-600 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-200 dark:hover:text-indigo-400"
          >
            <a
              href={href}
              className="flex w-full items-center justify-between text-sm font-medium"
              download={download}
              target={target}
              rel={rel}
            >
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SocialLinks
